module.exports = __webpack_public_path__ + "static/media/splash-viop.b0cef577.png";